import { begin, end } from '../defs-js/time'

const timeList = []
for (let h = begin; h <= end; h++) {
	timeList.push(`${h}:00`)
	if (h < end) {
		timeList.push(`${h}:30`)
	}
}

export default {
	name: 'TimeInput',
	props: {
		value: {
			type: String
		}
	},
	data () {
		return {
			val: this.value,
			timeList
		}
	},
	template: `
		<select
			v-model="val"
			@change="$emit('input', val)"
			class="form-control"
		>
			<option
				v-for="time in timeList"
				:key="time"
				:value="time"
			>
				{{ time }}
			</option>
		</select>
	`
}